import { ConcreteEncodable } from "./ConcreteEncodable";

import { StandardDateImplEncoder } from "../../encoder/StandardDateImplEncoder";

import * as CubiqTS from "../../index";
import { StandardDate } from "../StandardDate";

export class StandardDateImpl extends ConcreteEncodable implements StandardDate {
  public static enType: string = "com.bcdfx.model.StandardDateImpl";

  /*FID=1*/
  public day: number;
  /*FID=2*/
  public month: number;
  /*FID=3*/
  public year: number;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StandardDateImplEncoder.Instance;
    this.setEncodableType(StandardDateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StandardDateImpl[" +
      "day=" +
      this.day +
      "month=" +
      this.month +
      "year=" +
      this.year +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
